"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
const SvgIcon = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M280-280h120q17 0 28.5 11.5T440-240t-11.5 28.5T400-200H240q-17 0-28.5-11.5T200-240v-160q0-17 11.5-28.5T240-440t28.5 11.5T280-400zm400-400H560q-17 0-28.5-11.5T520-720t11.5-28.5T560-760h160q17 0 28.5 11.5T760-720v160q0 17-11.5 28.5T720-520t-28.5-11.5T680-560z"
}), 'ExpandContentRounded', {
  viewBox: "0 -960 960 960"
});
var _default = exports.default = SvgIcon;